import { createSlice } from '@reduxjs/toolkit';

const checkedItemsSlice = createSlice({
  name: 'checkedItems',
  initialState: [],
  reducers: {
    setCheckedItems: (state, action) => {
      //return action.payload;
      return Array.isArray(action.payload) ? action.payload : [action.payload];
    },
  },
});

export const { setCheckedItems } = checkedItemsSlice.actions;
export default checkedItemsSlice.reducer;